import { Value } from '@angular/fire/remote-config';

export const SET_REMOTE_CONFIG = '[RemoteConfig] Set';
export const REMOTE_CONFIG_NOT_AVAILABLE = '[RemoteConfig] not available';

export class SetRemoteConfig {
  readonly type = SET_REMOTE_CONFIG;
  constructor(public payload: Record<string, Value>) {}
}

export class RemoteConfigNotAvailable {
  readonly type = REMOTE_CONFIG_NOT_AVAILABLE;
}
